<template>
  <custom-select
    v-model="getEjercicio"
    :items="ejercicios"
    :label="label"
    hide-details>
  </custom-select>
</template>

<script>
import CustomSelect from './sinColumnas/Select.vue';

const EJERCICIO_INICIAL = 2021;
const EJERCICIO_PERIODO = 2024;

export default {
  name: 'EjercicioPicker',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default() {
        const hoy = new Date();
        return hoy.getFullYear();
      },
    },
    label: {
      type: String,
      required: false,
      default: 'Ejercicio',
    },
    sinPeriodo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CustomSelect,
  },
  data() {
    return {
      hoy: new Date(),
    };
  },
  computed: {
    getRangejercicios() {
      const esteEjercicio = this.hoy.getFullYear();
      return this.$range(EJERCICIO_INICIAL, (esteEjercicio + 2)).reverse();
    },
    ejercicios() {
      const ejercicios = [];
      this.getRangejercicios.forEach((ejercicio) => {
        if (ejercicio === EJERCICIO_PERIODO && !this.sinPeriodo) {
          ejercicios.push(`${ejercicio} - 1`);
          ejercicios.push(`${ejercicio} - 2`);
        } else {
          ejercicios.push(ejercicio);
        }
      });

      return ejercicios;
    },
    getEjercicio: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
